import { motion } from "motion/react";
import { Link } from "react-router-dom";

interface CTAProps {
  setIsContactModalOpen?: (open: boolean) => void;
}

export default function CTA({ setIsContactModalOpen }: CTAProps) {
  return (
    <section
      className="py-0 relative z-10 border-t border-black/10 dark:border-white/10"
      id="cta"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-indigo-500/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-purple-500/10 rounded-full blur-[100px] pointer-events-none" />
      <div className="container mx-auto px-6 text-center relative z-10">
        <motion.div
          initial={{ y: 40, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1] }}
          className="font-Montserrat text-xs tracking-widest uppercase text-indigo-600 dark:text-indigo-300/70 mb-6 flex items-center justify-center gap-4"
        >
          <div className="w-4 h-[1px] bg-indigo-500/50" /> Start Building{" "}
          <div className="w-4 h-[1px] bg-indigo-500/50" />
        </motion.div>
        <motion.h2
          initial={{ y: 40, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
          className="font-Montserrat text-5xl md:text-8xl font-bold tracking-tighter mb-6"
        >
          Ready to shape <br />{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-black dark:from-white via-indigo-600 dark:via-indigo-200 to-indigo-500/50 italic font-Montserrat">
            what's next?
          </span>
        </motion.h2>
        <motion.p
          initial={{ y: 24, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.23 }}
          className="max-w-md mx-auto text-black/50 dark:text-white/50 font-Monserrat text-base mb-12"
        >
          Tell us what you're envisioning. We'll build something extraordinary
          together.
        </motion.p>
        <motion.div
          initial={{ y: 24, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.31 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-6"
        >
          <button
            type="button"
            onClick={() => setIsContactModalOpen?.(true)}
            className="interactive font-Monserrat text-xs uppercase tracking-widest bg-black dark:bg-white text-white dark:text-black px-8 py-4 rounded-full hover:opacity-90 active:scale-[0.97] transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] w-full sm:w-auto shadow-[0_0_30px_rgba(99,102,241,0.2)] cursor-pointer"
          >
            Request Consultation
          </button>
          <Link
            to="/work"
            className="interactive font-Montserrat text-xs uppercase tracking-widest border border-black/20 dark:border-white/20 px-8 py-4 rounded-full hover:bg-black/5 dark:hover:bg-white/5 hover:border-indigo-500/50 active:scale-[0.97] transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] text-black dark:text-white w-full sm:w-auto inline-flex justify-center"
          >
            View Portfolio
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
